import { AxnAdminCacheState } from "@idw-types/state/axn-admin-cache-state";
import { AxnAdminCacheActionTypes, AxnAdminCacheActions } from "../actions/axn-admin-cache-actions";

export const initialAxnAdminCacheState: AxnAdminCacheState = {
    isRefreshing: false,
    lastRefreshDate: null,
    refreshResults: null
};

export const axnAdminCacheReducer = (
    state: AxnAdminCacheState = initialAxnAdminCacheState,
    action: AxnAdminCacheActions
): AxnAdminCacheState => {
    switch(action.type) {
        case AxnAdminCacheActionTypes.SET_AXN_ADMIN_CACHE_REFRESHING:
            return {
                ...state,
                isRefreshing: action.payload.isRefreshing
            };
        case AxnAdminCacheActionTypes.SET_AXN_ADMIN_CACHE_REFRESH_RESULTS:
            return {
                ...state,
                isRefreshing: false,
                refreshResults: action.payload.refreshResults,
                lastRefreshDate: action.payload.lastRefreshDate,
            };
        default:
            return state;
    }
};